import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "details-events",
  style: {"background":"#FFF"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex flex-column justify-content-center align-items-center py-8" }
const _hoisted_4 = { class: "my-8 h1 text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left-circle-fill fs-2" }, null, -1)
const _hoisted_6 = { class: "content-menu bg-light border-2 border-bottom border-secondary" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "d-flex overflow-auto h-55px justify-content-center" }
const _hoisted_9 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item d-none" }
const _hoisted_12 = { class: "nav-item d-none" }
const _hoisted_13 = { class: "nav-item d-none" }
const _hoisted_14 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_avatar, {
            size: 120,
            src: _ctx.evento.logo,
            class: "bg-white p-2 shadow"
          }, null, 8, ["src"]),
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.evento.name), 1),
          _createVNode(_component_router_link, {
            class: "btn btn-light",
            to: "/public/tournaments"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode("volver")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/public/tournaments/${_ctx.id}/sports`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Deportes ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/public/tournaments/${_ctx.id}/teams`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Equipos ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/public/tournaments/${_ctx.id}/staff`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Staff/Árbitros ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/public/tournaments/${_ctx.id}/sponsors`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Sponsors ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}